<template>
  <div class="settings-toggle-row">
    <h3 class="settings-toggle-row__title">{{ title }}</h3>
    <p :id="descriptionId" class="settings-toggle-row__description">
      {{ description }}
    </p>
    <div class="settings-toggle-row__control">
      <div class="switch">
        <div class="can-toggle">
          <input
            :id="inputId"
            class="input"
            type="checkbox"
            :checked="value"
            :aria-describedby="descriptionId"
            @change="onChange"
          />
          <label
            :for="inputId"
            :class="value ? 'power-on' : 'power-off'"
          >
            <div class="switch-body flex-mid">
              <div v-if="value" class="mr-auto ml-14 mt-2">ON</div>
              <div v-else class="ml-auto mr-10 mt-2">OFF</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsToggleRow",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  computed: {
    inputId() {
      return this.id || `settings-toggle-${this._uid}`;
    },
    descriptionId() {
      return `${this.inputId}-description`;
    },
  },
  methods: {
    onChange(event) {
      this.$emit("change", event.target.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-toggle-row {
  margin-top: 24px;

  &__title {
    margin: 0 0 6px;
    font-size: 18px;
    font-weight: 700;
    color: #000000;
  }

  &__description {
    margin: 0;
    font-size: 14px;
    color: #4a4a4a;
    max-width: 740px;
  }

  &__control {
    margin-top: 14px;
  }
}
</style>
